import { AuthenticationService, Parse } from 'app/data/services';
import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { EUserLogLevel } from './data/models';
import { HttpClient } from '@angular/common/http';
import { environment } from '@app/data/common-imports';

enum EMessageType {
    LOG = 'LOG',
    WARNING = 'WRN',
    ERROR = 'ERR',
    TRACE = 'TRC',
    EXCEPTION = 'EXC',
    W3BLIB = 'W3BLIB'
}

@Injectable()
export class GlobalLoggingHandler extends ErrorHandler {

    //private storage = new Array<{ type: EMessageType, time: number, msg: string }>();
    private origConsoleLog;
    private invalidSessionRecoveryStarted = false;
    //private authenticationService: AuthenticationService = null;
    //private http: HttpClient;
    constructor(private injector: Injector) {
        super();
        /*
        this.http = injector.get(HttpClient);
        if (localStorage && localStorage.getItem('msgStorage')) {
            this.storage = JSON.parse(localStorage.getItem('msgStorage'));
        }
        */
        Error.stackTraceLimit = 100;
        this.origConsoleLog = console.log;
        const origConsoleWarn = console.warn;
        const origConsoleError = console.error;
        const origConsoleTrace = console.trace;
        console.log = (msg) => {
            if (msg && msg.special && msg.msg) {
                const special = msg.special;
                msg = msg.msg;
                if (special === 'W3BLIB') {
                    this.handleMessage(EMessageType.W3BLIB, msg);
                }
            }
            this.origConsoleLog(msg);
        };

        console.warn = (msg) => {
            origConsoleWarn(msg);
            this.handleMessage(EMessageType.WARNING, msg);
        };

        console.trace = (msg) => {
            origConsoleTrace(msg);
            const obj = { stack: undefined };
            Error.captureStackTrace(obj);
            this.handleMessage(EMessageType.TRACE, obj.stack);
        };

        console.error = (msg) => {
            origConsoleError(msg);
            this.handleMessage(EMessageType.ERROR, msg);
            console.trace();
        };

        setInterval(() => {
            //this.persistMessages();
        }, 5000);
    }
    handleError(error: Error) {
        if (this.isInvalidSessionError(error)) {
            this.recoverInvalidSession();
            return;
        }
        this.handleMessage(EMessageType.EXCEPTION, JSON.stringify(error.stack));
        this.showFatalError(error);
        throw error;
    }

    private isInvalidSessionError(error: any) {
        const candidates = [error, error?.rejection, error?.originalError, error?.error, error?.reason];
        return candidates.some(candidate =>
            [206, 209].includes(Number(candidate?.code)) ||
            /invalid session token/i.test(String(candidate?.message || candidate || ''))
        );
    }

    private recoverInvalidSession() {
        if (this.invalidSessionRecoveryStarted) return;
        this.invalidSessionRecoveryStarted = true;

        localStorage.removeItem('W3BOOSTER_ADMIN_SESSION_TOKEN');
        localStorage.removeItem('W3BOOSTER_IMPERSONATION');
        const applicationId = (Parse as any).CoreManager?.get?.('APPLICATION_ID');
        if (applicationId) localStorage.removeItem(`Parse/${applicationId}/currentUser`);

        let logout: Promise<any>;
        try {
            logout = Promise.resolve(Parse.User.logOut());
        } catch (_error) {
            logout = Promise.resolve();
        }
        logout.catch(() => undefined).then(() => window.location.replace('/login'));
    }

    private showFatalError(error: any) {
        if (!document?.body || document.getElementById('w3-fatal-error')) return;
        const panel = document.createElement('div');
        panel.id = 'w3-fatal-error';
        panel.setAttribute('style', 'position:fixed;z-index:2147483647;left:24px;right:24px;bottom:24px;max-height:42vh;overflow:auto;padding:16px 18px;border:1px solid #9f4f47;border-left:4px solid #dc6a5c;border-radius:5px;background:#171113;color:#f0dcda;font:12px/1.45 Consolas,monospace;box-shadow:0 16px 50px #000;white-space:pre-wrap');
        panel.textContent = 'W3Booster could not finish loading\n\n' + (error?.stack || error?.message || String(error));
        document.body.appendChild(panel);
    }

    private handleMessage(type: EMessageType, message) {
        let msg = '';
        try {
            msg = (message instanceof Object) ? JSON.stringify(message) : message;
        } catch (e) {
            msg = 'circular issue';
        }
        this.origConsoleLog(msg);
        //this.storage.push({ type: type, time: new Date().getTime(), msg: msg });
/*
        if (localStorage) {
            localStorage.setItem('msgStorage', JSON.stringify(this.storage));
        }
        */
    }
/*
    private persistMessages() {
        if (!this.authenticationService) {
            this.authenticationService = this.injector.get(AuthenticationService);
        }

        if (this.storage.length > 0 && this.authenticationService && this.authenticationService.isInitialized()) {
            const user = this.authenticationService.getAuthenticatedUser();

            if (user) {
                if (this.storage.length > 200) {
                    this.storage = this.storage.slice(this.storage.length - 200);
                    if (localStorage) {
                        localStorage.setItem('msgStorage', JSON.stringify(this.storage));
                    }
                }

                if (user.logLevel === EUserLogLevel.DEFAULT) {
                    this.storage = this.storage.filter(entry => entry.type !== EMessageType.LOG);
                }

                const submittedLines = this.storage.length;
                this.http.post(environment.REST_URL + 'w3alias/logUpdate/0', {
                    data: this.storage.map(entry => {
                        if (entry.type === EMessageType.W3BLIB) {
                            const line = '[LIBSTD]' + entry.msg.replace(/\n/g, '\n[LIBSTD]');
                            return line.substr(0, line.length - '[LIBSTD]'.length);
                        } else {
                            return '[WEB' + entry.type + '][' + new Date(entry.time).toLocaleTimeString('de-DE') + '] ' + entry.msg;
                        }
                    }).join('\r\n')
                }, { responseType: 'text' }).toPromise().then(() => {
                    this.storage = this.storage.slice(submittedLines);
                    if (localStorage) {
                        localStorage.setItem('msgStorage', JSON.stringify(this.storage));
                    }
                });

            }
        }
    }
    */
}
